import { css } from '@emotion/react';

export function getOnboardingPageStyles() {
    return css({
        height: '100%',
    });
}

export function getHeaderStyles() {
    return css({
        textAlign: 'center',
        margin: 0,
    });
}
